import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface State {
  ids: number[];
  showStats: boolean;
}

const chambersMap = createSlice({
  name: 'chambersMap',
  initialState: {
    ids: [],
    showStats: true,
  } as State,
  reducers: {
    setVisibleIds(state: State, { payload }: PayloadAction<number[]>) {
      state.ids = payload;
    },
    setShowStats(state: State, { payload }: PayloadAction<boolean>) {
      state.showStats = payload;
    },
  },
});

export const chambersMapStore = {
  reducer: chambersMap.reducer,
  actions: chambersMap.actions,
};
